var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.71429 6.42888V3.71444C8.71429 2.08578 7.42857 1 5.5 1C3.57143 1 2.28571 2.08578 2.28571 3.71444V6.42888M5.5 8.60043V10.772M5.5 12.9435C3.01472 12.9435 1 11.2421 1 9.14331C1 7.04451 3.01472 5.3431 5.5 5.3431C7.98528 5.3431 10 7.04451 10 9.14331C10 11.2421 7.98528 12.9435 5.5 12.9435ZM5.5 9.14331C5.14496 9.14331 4.85714 8.90025 4.85714 8.60043C4.85714 8.3006 5.14496 8.05754 5.5 8.05754C5.85504 8.05754 6.14286 8.3006 6.14286 8.60043C6.14286 8.90025 5.85504 9.14331 5.5 9.14331Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.645f74f555a16238f0aa39e7e0c9e74d.svg";
export { ForwardRef as ReactComponent };